import { Trash2, ChevronRight, Archive, ArchiveRestore } from "lucide-react";
import { CATEGORY_STYLE, STATUS_STYLE, fmtDate } from "@/lib/format";

function Badge({ children, cls }) {
  return <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-semibold ${cls || "bg-slate-100 text-slate-600"}`}>{children}</span>;
}

export function LeadsTable({ loading, leads, onRowClick, onArchive, onDelete }) {
  let body;
  if (loading) {
    body = <tr><td colSpan={8} className="px-4 py-10 text-center text-[#9aa6c0]">Chargement…</td></tr>;
  } else if (leads.length === 0) {
    body = <tr><td colSpan={8} className="px-4 py-10 text-center text-[#9aa6c0]">Aucun lead trouvé.</td></tr>;
  } else {
    body = leads.map((l) => (
      <tr key={l.id} data-testid={`lead-row-${l.id}`}
        onClick={() => onRowClick(l.id)}
        className="border-t border-[#eef1f6] hover:bg-[#f8f9fc] cursor-pointer">
        <td className="px-4 py-3 text-[#4b5b7c] whitespace-nowrap">{fmtDate(l.created_at)}</td>
        <td className="px-4 py-3">
          <div className="font-semibold text-[#1a2d56]">{l.first_name} {l.last_name}</div>
          <div className="text-xs text-[#9aa6c0]">{l.email}</div>
        </td>
        <td className="px-4 py-3 text-[#1a2d56] max-w-[180px]">{l.profile_primary_name}</td>
        <td className="px-4 py-3">
          <span className="font-bold text-[#1a2d56]">{l.commercial_score}</span>
          <span className="text-[#9aa6c0]">/100</span>
        </td>
        <td className="px-4 py-3">
          <Badge cls={CATEGORY_STYLE[l.category]}>{l.category}</Badge>
        </td>
        <td className="px-4 py-3"><Badge cls={STATUS_STYLE[l.status]}>{l.status}</Badge></td>
        <td className="px-4 py-3 text-[#4b5b7c] whitespace-nowrap">{l.source}</td>
        <td className="px-4 py-3 whitespace-nowrap">
          <button data-testid={`archive-lead-${l.id}`} onClick={(e) => onArchive(e, l.id, !l.archived)}
            title={l.archived ? "Désarchiver" : "Archiver"}
            className="text-[#9aa6c0] hover:text-[#1a2d56] p-1">
            {l.archived ? <ArchiveRestore size={16} /> : <Archive size={16} />}
          </button>
          <button data-testid={`delete-lead-${l.id}`} onClick={(e) => onDelete(e, l)}
            title="Supprimer définitivement"
            className="text-[#9aa6c0] hover:text-rose-600 p-1"><Trash2 size={16} /></button>
          <ChevronRight size={16} className="inline text-[#cbd5e1]" />
        </td>
      </tr>
    ));
  }

  return (
    <div className="bg-white rounded-2xl border border-[#e2e8f0] overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="leads-table">
          <thead className="bg-[#f8f9fc] text-[#4b5b7c] text-left">
            <tr>
              {["Date", "Prospect", "Profil", "Score", "Catégorie", "Statut", "Source", ""].map((h) => (
                <th key={h} className="px-4 py-3 font-semibold whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>{body}</tbody>
        </table>
      </div>
    </div>
  );
}
